export const CloseIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M4 4L12 12M12 4L4 12"
      stroke="#FFFFFF"
      strokeWidth="1.33"
      strokeLinecap="round"
    />
  </svg>
);
